<template>
  <div>
    <NuxtPage />
    <ContactForm v-if="renderedSlug === 'contact'" class="pt-24" />
    <Special v-else id="subscribe" v-bind="subscribe" />
  </div>
</template>

<script setup lang="ts">
const route = useRoute()
const renderedSlug = ref(route.params.slug)

const subscribe = ref({
  body: `Subscribe to our email list if you’d like us to let you know about future Journal Clubs, Insight Webinars, and for other updates from IPC Partners.`,
  title: 'Subscribe',
  theme: 'blue',
  component: 'subscribe-form',
})

const nuxtApp = useNuxtApp()
onMounted(() => {
  // Set initial slug
  renderedSlug.value = route.params.slug
})

// After a page transition finishes, update slug
nuxtApp.hook('page:transition:finish', () => {
  renderedSlug.value = route.params.slug
})
</script>
